import { workTemplateService } from 'ogp/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import {
  CreateWorkTemplatePayload,
  CreateWorkTemplateResponse,
} from '../../../services/work-template-service.types';

type JobMutationOptions = UseMutationOptions<
  CreateWorkTemplateResponse,
  unknown,
  CreateWorkTemplatePayload
>;

export const useCreateWorkTemplate = () => {
  const mutationFn = async (job: CreateWorkTemplatePayload) =>
    await workTemplateService.createWorkTemplate(job);

  const queryClient = useQueryClient();
  const mutationOptions: JobMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.workTemplates());
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
